<template>
  <div id="login">
    <h2>Login</h2>
    <el-form
      novalidate="true"
      label-width="8em"
      :label-position="formLabelPosition"
      :size="formSize"
      v-loading="loginStatus == 'pending'"
    >
      <el-alert
        v-if="accountExists"
        title="You must log in with your email for this account."
        type="error" />
        <div class="fb-login-container">
          <div class="fb-login-button" data-width="" data-size="large" data-button-type="continue_with" data-auto-logout-link="false" data-use-continue-as="true" :onlogin="'window.fbLoginCallback(\'' + this.getRedirect() + '\')'"></div>
        </div>
        <div class="divider"></div>
      <el-form-item label="Email address" :error="errors.email">
        <el-input placeholder="Enter your email" v-model="email"></el-input>
      </el-form-item>
      <el-form-item label="Password" :error="errors.password">
        <el-input placeholder="Enter your password" v-model="password" show-password></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" v-on:click="login">Login</el-button>
        <router-link class="forgot-password" v-if="$route.name != 'password'" :to="{name: 'password'}">I forgot my password</router-link>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import formMixin from '../mixins/formMixin'
  import sessionMixin from '../mixins/sessionMixin'
  import facebookMixin from '../mixins/facebookMixin'

  export default {
    props: ['accountExists'],
    mixins: [formMixin, sessionMixin, facebookMixin],
    methods: {
      login() {
        this.$store.dispatch('session/login', { email: this.email, password: this.password })
      }
    },
    computed: {
      ...mapState({
        loginStatus: state => state.session.status.login,
        user: state => state.session.user,
        errors: state => state.session.errors
      })
    },
    watch: {
      user() {
        if (this.user) {
          this.redirect()
        }
      }
    },
		mounted() {
			const self = this
      if (typeof FB != 'undefined')
			  FB.XFBML.parse()
		},
    data() {
      return {
        email: '',
        password: ''
      }
    }
  }
</script>
<style scoped>
  .el-alert {
    margin-bottom: 1em;
  }
  .divider {
    border-bottom: 1px solid #ddd;
    margin: 1em 0;
  }
  .fb-login-container {
    text-align: left;
  }
  .forgot-password {
    color: #0c71c3;
    text-decoration: none;
    margin-left: 1em;
  }
</style>
